module.exports = __webpack_public_path__ + "img/19292088.923f839f.jpg";